import React from 'react';
import styled from 'styled-components';
import Attribution from '../../../../shared/components/Attribution';
import Columns, { Column } from '../../../../shared/components/Columns';
import DesignCard from '../../../../shared/components/DesignCard';
import Heading from '../../../../shared/components/Heading';
import { colors, media, spaces } from '../../../../shared/lib/styles';
import Box from '../../../../shared/spa/core-components/Box';
import Stack from '../../../../shared/spa/core-components/Stack';
import { publicImageUrl } from '../../../lib/publicImageUrl';

const CardWrapper = styled.div`
    max-width: 393px;
`;

const StyledRelatedCategories = styled.div`
    margin-top: ${spaces.space10}px;

    @media ${media('small', 'medium')} {
        ${Column}:first-child {
            display: none;
        }
    }
`;

export default function RelatedCategories() {
    return (
        <StyledRelatedCategories>
            <Columns>
                <Column width={[12, 12, 4, 4]}>
                    <CardWrapper>
                        <DesignCard
                            src={publicImageUrl('product-landing/cindric-sketch.jpeg')}
                            width={393}
                            height={393}
                            variations={['heavy-shadow']}
                            alt={__('hand drawn pen sketches of a pig by cindric')}
                        />
                    </CardWrapper>
                </Column>
                <Column width={[12, 6, 4, 4]}>
                    <Box
                        paddingTop={['none', 'none', 'space12', 'space12']}
                        marginBottom={['space10', 'none', 'none', 'none']}
                    >
                        <CardWrapper>
                            <DesignCard
                                src={publicImageUrl('product-landing/cindric-business-card.jpeg')}
                                attribution={<Attribution name="cindric" />}
                                width={393}
                                height={393}
                                variations={['heavy-shadow']}
                                alt={__("a business card for 'Piggypay' designed by cindric")}
                            />
                        </CardWrapper>
                    </Box>
                </Column>
                <Column width={[12, 6, 4, 4]}>
                    <Stack space={'space7'}>
                        <Heading
                            type="h4"
                            variations={['h4', 'no-margin']}
                            style={{ color: colors.heritage }}
                        >
                            {__('What is a logo design and why is it important?')}
                        </Heading>
                        <Box>
                            {`${__(
                                'Logo design is the process of arranging symbols, images, text and color to create a unique mark that communicates the essence of your brand.'
                            )} `}
                        </Box>
                        <Box>
                            {__(
                                `A great business logo is the cornerstone of your brand identity. You’ll use it for all parts of your company: on your website, social media, physical products, packaging, marketing materials and in stores. A great logo helps customers understand what you do and what sets you apart from the competition. It can be the difference between a one-time purchase and creating a long-term ongoing relationship with your customers.`
                            )}
                        </Box>
                    </Stack>
                </Column>
            </Columns>
        </StyledRelatedCategories>
    );
}
